import React from "react";
import { Footer, Navbar } from "../components";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../context/authContext";
import { Alert } from "../components/Alert";
const Login = () => {
  const [user, setUser] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { login, loginWithGoogle, resetPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await login(user.email, user.password);
      navigate("/");
    } catch (error) {
      setError(error.message);
      if (error.code === "auth/internal-error") {
        setError("Correo invalido.");
      }
    }
  };

  const handleGoogleSignin = async () => {
    try {
      await loginWithGoogle();
      navigate("/");
    } catch (error) {
      setError(error.message);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (!user.email) return setError("Write an email to reset password");
    try {
      await resetPassword(user.email);
      setError("We sent you an email. Check your inbox");
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center">Acceder</h1>
        <hr />
        <div class="row my-4 h-100">
          <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
            {error && <Alert message={error} />}
            <form onSubmit={handleSubmit}>
              <div class="my-3">
                <label for="display-4">Correo electrónico</label>
                <input
                  type="email"
                  class="form-control"
                  id="Email"
                  placeholder="name@ejemplo.com"
                  onChange={(e) => setUser({ ...user, email: e.target.value })}
                />
              </div>
              <div class="my-3">
                <label for="floatingPassword display-4">Contraseña</label>
                <input
                  type="password"
                  class="form-control"
                  id="Password"
                  placeholder="Password"
                  onChange={(e) =>
                    setUser({ ...user, password: e.target.value })
                  }
                />
              </div>
              <div className="my-3">
                <p>
                  ¿Nuevo aqui?{" "}
                  <Link
                    to="/register"
                    className="text-decoration-underline text-info"
                  >
                    Registrar
                  </Link>{" "}
                </p>
                <a
                  className="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800"
                  href="#!"
                  onClick={handleResetPassword}
                >
                  ¿Olvidaste tu contraseña?
                </a>
              </div>
              <div className="text-center">
                <button
                  class="my-2 mx-auto btn btn-dark"
                  type="submit"
                  onSubmit={handleSubmit}
                >
                  Acceder
                </button>
                <button
                onClick={handleGoogleSignin}
                className="bg-slate-50 hover:bg-slate-200 text-black  shadow rounded border-2 border-gray-300 py-2 px-4 w-full"
              >
                Acceder con Google
              </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Login;
